var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBxEditAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.045 7.90234C19.423 7.52434 19.631 7.02234 19.631 6.48834C19.631 5.95434 19.423 5.45234 19.045 5.07434L17.459 3.48834C17.081 3.11034 16.579 2.90234 16.045 2.90234C15.511 2.90234 15.009 3.11034 14.632 3.48734L4 14.0863V18.5013H8.413L19.045 7.90234ZM16.045 4.90234L17.632 6.48734L16.042 8.07134L14.456 6.48634L16.045 4.90234ZM6 16.5013V14.9163L13.04 7.89834L14.626 9.48434L7.587 16.5013H6ZM4 20.5013H20V22.5013H4V20.5013Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxEditAlt);
export default __webpack_public_path__ + "static/media/bx-edit-alt.128654be171218465f22d49f947f0e5a.svg";
export { ForwardRef as ReactComponent };